module.exports = __webpack_public_path__ + "static/media/tiny_img_3.de99336f.png";